export default {"src":"/_next/static/media/legends-league.ddf20577.svg","height":130,"width":327,"blurWidth":0,"blurHeight":0};